<template>
  <div id="content-container" class="mw-100"
       @click="onClick">
    <sidebar-menu ref="sidebar"
                  :menu="routeViews"
                  id="my-sidebar"
                  @toggle-collapse="onCollapse"
                  @item-click="onClick"
                  v-show="logged && $route.path !== '/awdoc'"
                  :collapsed="collapsed"
                  :relative="true">
      <span slot="toggle-icon">
        <font-awesome-icon icon="bars"/>
      </span>
    </sidebar-menu>

    <!-- Do not use "v-if" or "v-show" on #hide-content it will brake routing -->
    <div id="hide-content" class="w-100 flex-column"
         :style="`display: ${showContent ? 'flex!important' : 'none!important'}`">
      <b-breadcrumb :items="items" v-if="logged && $route.path !== '/awdoc'" id="my-breadcrumb"/>

      <transition :name="transition" mode="out-in" @after-enter="checkWindowSize()" @after-leave="checkWindowSize()">
        <router-view id="router-view-content" ref="routeView" style="flex-grow: 1"/>
      </transition>

      <link-list refs="linkList" v-if="logged" @clicked-link="linkClicked"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { first, difference } from 'lodash'
import routeViews from '../router-views'


export default {
  name: 'MainContent',
  watch: {
    '$route' (to, from) {
      this.checkRoute(to, from)
    },
    'window' () {
      this.checkWindowSize()
    },
    collapsed () {
      this.checkWindowSize()
    },
    showContent () {
      this.checkWindowSize()
    }
  },
  data () {
    const section = Vue.getLocalStorage('session')
    return {
      logged: section && section.token,
      routeViews: [],
      size: 'cols',
      collapsed: false,
      showContent: false,
      transition: 'slide-right',
      items: [
        { text: 'Home', href: '#/home', active: true }
      ],
      to: {},
      from: {}
    }
  },
  created () {
    this.checkRoute(this.$route)
  },
  mounted () {
    let routes = Vue.getLocalStorage('routes')
    routes = routes ? JSON.parse(atob(routes)) : null

    this.checkWindowSize()
    this.routeViews = routeViews.sidebarItems(this, routes)
    this.items = Vue.myChangeBreadcrumb(this, this.$route)

    this.$root.$on('change-lang', () => {
      this.routeViews = routeViews.sidebarItems(this, routes)
      this.items = Vue.myChangeBreadcrumb(this, this.$route)
    })
    this.$root.$on('loggedIn', () => {
      routes = JSON.parse(atob(Vue.getLocalStorage('routes')))
      this.routeViews = routeViews.sidebarItems(this, routes)
      this.items = Vue.myChangeBreadcrumb(this, this.$route)
    })
    this.$root.$on('app-clicked', () => {
      this.onClick()
    })
    this.$root.$on('resize', () => {
      this.checkWindowSize()
    })
    this.checkSidebar()
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.checkWindowSize()
    })
  },
  methods: {
    linkClicked (link) {
      if (this && this.$refs && this.$refs.routeView && this.$refs.routeView.clickedLink) {
        this.$refs.routeView.clickedLink(link)
      }
    },
    onCollapse (collapsed) {
      this.collapsed = collapsed
      this.checkWindowSize()
    },
    onClick (event) {
      const menu = document.getElementsByClassName('vsm--mobile-item')
      if (menu && first(menu)) first(menu).style.visibility = 'visible'
      if (event && event.toElement && event.toElement.className === 'vsm--title' && this.collapsed) {
        if (menu && first(menu)) first(menu).style.visibility = 'hidden'
      }
    },
    checkWindowSize () {
      const size = Vue.myGetWindowSize()
      this.size = size
      if (size === 'lg' || size === 'xl') {
        this.showContent = true
      } else {
        this.showContent = !this.logged || (this.logged && this.collapsed)
      }
    },
    checkRoute (to, from) {
      const section = Vue.getLocalStorage('session')
      const inactive = Vue.getLocalStorage('inactive')
      const tabs = Vue.getLocalStorage('tabs')
      const hasPermissions = Vue.getConfigByRouteItem(to)
      this.logged = !!(section && section.token)
      this.checkWindowSize()

      if (from) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      } else if (inactive >= tabs && tabs !== null) {
        Vue.deleteLocalStorage('session')
        this.$router.push('/')
      }
      if (to.path === '/awdoc') {
        this.$router.push('/awdoc')
      } else if (this.logged && hasPermissions) {
        this.checkSidebar()
        this.items = Vue.myChangeBreadcrumb(this, to)
        if (to.path === '/') {
          this.$router.push({ name: 'Home' })
        }
        this.to = to
        this.from = from
        if (this.$refs.linkList) {
          this.$root.$emit('change-links', to.meta.links)
        } else {
          this.$root.$emit('reset-links')
        }

        if (hasPermissions && hasPermissions.config) to.meta.config = hasPermissions.config

        if (this.isSpecialRoute(this.to.fullPath)) {
          Vue.myLogPost(Vue.getLogObj(this.to, 'get', this.to.fullPath))
        }
      } else if (hasPermissions) {
        this.$router.push({ name: 'Login' })
      } else {
        this.$router.push('/path_not_active')
      }
    },
    isSpecialRoute (path) {
      let foundedRoute = false
      const specialPaths = [
        '/map', '/report/travel', '/redirect'
      ]

      specialPaths.forEach(specialPath => {
        if (!foundedRoute) foundedRoute = specialPath === path
      })
      return !foundedRoute
    },
    checkSidebar () {
      if (!this.showContent && this.$refs.sidebar) {
        this.$refs.sidebar.$el.lastChild.click()
      }
    }
  }
}
</script>

<style scoped>
.slide-right-enter-active {
  transition: all .3s ease;
}
.slide-right-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-right-enter {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-right-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.slide-left-enter-active {
  transition: all .3s ease;
}
.slide-left-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-left-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>
